import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var Arrow = function Arrow(_ref) {
  var Component = _ref.Component,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$customClassName = _ref.customClassName,
    customClassName = _ref$customClassName === void 0 ? '' : _ref$customClassName;
  return /*#__PURE__*/_jsx(Component, {
    "data-test-id": "D3oyMgOjPdhaMiZRQyVbG",
    className: classNames(className, customClassName),
    style: style,
    onClick: onClick,
    onKeyPress: onClick,
    role: "button",
    tabIndex: 0
  });
};
export default Arrow;